import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import logo from "content/images/logo.svg"

import { siteShortTitle } from "../../config"

const StyledLogo = styled.img`
  position: relative;
  z-index: 13;
  width: 8rem;
  height: 3rem;
  /* Disable effects when sidebar is open */
  filter: none !important;
  pointer-events: auto !important;
  user-select: auto !important;
`

const Logo = ({ size, color }) => (
  <StyledLogo src={logo} alt="logo" />
)

Logo.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
}

export default Logo
